import { cn } from "@theprelude/core";

export const PlayIcon: React.FC<React.ComponentPropsWithoutRef<"svg">> = ({
  className,
  ...props
}) => (
  <svg
    className={cn("size-4 flex-shrink-0", className)}
    {...props}
    viewBox="0 0 16 16"
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M11.3797 7.51412L4.83443 2.76485C4.75369 2.70621 4.65985 2.67251 4.56291 2.66733C4.46597 2.66215 4.36955 2.68569 4.28393 2.73544C4.1983 2.7852 4.12668 2.8593 4.07668 2.94986C4.02668 3.04042 4.00018 3.14405 4 3.24971V12.7512C4.00034 12.8566 4.02688 12.96 4.07681 13.0503C4.12675 13.1406 4.1982 13.2146 4.28361 13.2643C4.36902 13.314 4.46519 13.3376 4.56193 13.3326C4.65867 13.3277 4.75237 13.2943 4.83309 13.236L11.3797 8.48676C11.4533 8.43344 11.5137 8.36114 11.5554 8.2763C11.5972 8.19145 11.619 8.09669 11.619 8.00044C11.619 7.90419 11.5972 7.80943 11.5554 7.72459C11.5137 7.63975 11.4533 7.56745 11.3797 7.51412Z" />
  </svg>
);
